'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.np-root {\n  position: absolute;\n  right: 10px;\n  color: #1D66DD;\n  display: flex;\n  text-decoration: unset;\n  width: 45px;\n  height: 30px;\n}");
//# sourceMappingURL=NavbarProfile.scss.js.map
